<template>
  <div class="page padding">
    <modal-category ref="modalCategory" />
    <modal-new-element ref="modalNewElement" />
    <modal-show-element
      ref="modalShowElement"
      @deleted="fetchPostsRecursos(nodeSelected)"
      @updated="fetchPostsRecursos(nodeSelected)"
    />

    <b-row
      v-if="$role(['administrador'])"
      class="d-flex align-items-center text-right mb-3"
    >
      <b-col xs="12">
        <b-dropdown
          text="Categorías"
          no-caret
          class="m-md-2 context-menu"
          variant="primary"
        >
          <b-dropdown-item @click="addCategory(null)">Agregar Categoría Padre</b-dropdown-item>
          <b-dropdown-item
            :disabled="hasChildren || !nodeSelected"
            @click="addCategory(nodeSelected)"
          >Agregar Subcategoría</b-dropdown-item>
          <b-dropdown-item @click="editCategory(nodeSelected)">Editar</b-dropdown-item>
          <b-dropdown-item :disabled="hasChildren || !nodeSelected" @click="deleteCategory(nodeSelected)">Eliminar</b-dropdown-item>
        </b-dropdown>
        <b-btn
          :disabled="hasChildren || !nodeSelected"
          :variant="hasChildren || !nodeSelected ? 'dark' : 'primary'"
          @click="openNewPostDialog"
        >Nuevo Recurso</b-btn>
      </b-col>
    </b-row>

    <b-row class="mt-2">
      <b-col sm="4">
        <b-card no-body>
          <b-card-header>
            Categorías
          </b-card-header>
          <tree-item
            v-for="item of categoriasRecursos"
            :key="item.id"
            :item="item"
            :node-selected="nodeSelected"
            @selected="setSelectedNode"
          />

        </b-card>
      </b-col>
      <b-col sm="8">
        <b-card
          no-body
          v-if="nodeSelected"
          :header="currentCategory"
        >
          <b-list-group>
            <b-list-group-item
              href="#"
              v-for="post in postsRecursos"
              :key="post.id"
              @click="showElement(post.id)"
            >{{ post.titulo }}</b-list-group-item>
          </b-list-group>
        </b-card>

        <b-alert :show="!nodeSelected">Seleccione una categoría</b-alert>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ModalNewElement from '@/components/Recursos/ModalNewElement.vue'
import ModalShowElement from '@/components/Recursos/ModalShowElement.vue'
import ModalCategory from '@/components/Recursos/ModalCategory.vue'
import TreeItem from '@/components/Recursos/TreeItem.vue'
import { mapGetters, mapActions } from 'vuex';
export default {
  components: {
    ModalNewElement,
    ModalShowElement,
    ModalCategory,
    TreeItem
  },

  data () {
    return {
      nodeSelected: null,
      currentCategory: null
    }
  },

  computed: {
    ...mapGetters(['categoriasRecursos', 'postsRecursos']),
    hasChildren () {
      const item = this.$store.state.recursos.categorias.find(c => c.id === this.nodeSelected)
      if (item) {
        return item.children && item.children.length
      }
      return false
    }
  },

  methods: {
    ...mapActions(['fetchCategoriasRecursos', 'fetchPostsRecursos']),
    addCategory (parentId) {
      this.$refs.modalCategory.categoria.id_padre = parentId
      this.$refs.modalCategory.visible = true
    },
    setSelectedNode ({ id, nombre, children }) {
      this.currentCategory = nombre
      this.nodeSelected = id
      if (!children || !children.length) {
        this.fetchPostsRecursos(id)
      }
    },
    editCategory (id) {
      this.$refs.modalCategory.categoria.id = id
      this.$refs.modalCategory.visible = true
    },
    async deleteCategory (id) {
      if (id) {
        await this.fetchPostsRecursos(id)
        if (this.postsRecursos.length) {
          this.$toast.error('No se puede eliminar la categoría seleccionada porque contiene elementos que dependen de ella.')
        } else {
          this.$api.delete('recursos/categoria/' + id).then(() => {
            this.fetchCategoriasRecursos()
            this.nodeSelected = null
            this.$toast.success('Categoría eliminada')
          })
        }
      }
    },
    openNewPostDialog () {
      if (!this.nodeSelected) {
        return this.$toast.warning('Debe seleccionar una categoría primero')
      }
      this.$refs.modalNewElement.post.id_categoria = this.nodeSelected
      this.$refs.modalNewElement.visible = true
    },

    showElement (id) {
      this.$refs.modalShowElement.id = id
      this.$refs.modalShowElement.visible = true
    }
  },

  mounted () {
    this.fetchCategoriasRecursos()
  }
}
</script>
